import axios, { AxiosResponse } from 'axios';

export enum EZnekativneniStav {
    SMAZAN = 'SMAZAN', // účet byl smazán (neexistovala žádná žádost ani služba)
    ZNEAKTIVNEN = 'ZNEAKTIVNEN' // účet byl zneaktivněn (existuje žádost nebo služba na tomto účtu)
}
export interface IZruseniResp {
    stav: EZnekativneniStav;
}
const zneaktivneniUctuApi = (id: string, pw: string) => {
    return axios({
        method: 'DELETE',
        url: `/Portal/Ucet/${id}`,
        data: {
            password: pw
        }
    }).then((resp: AxiosResponse<IZruseniResp>) => resp.data);
};

export default zneaktivneniUctuApi;
